import { StaticQueryDocument, graphql, useStaticQuery } from "gatsby";
import { useApp } from "./useApp";

export enum FilterUsernames {
  baredfootwear = "baredfootwear",
  baredfootwearmens = "baredfootwearmens",
}

export const useInstagram = (username?: string) => {
  const {
    config: {
      settings: { routes },
    },
  } = useApp();

  const query: StaticQueryDocument = graphql`
    query INSTAGRAM_FEED {
      baredfootwear: allSanityInstagram(
        filter: { timestamp: { ne: "" }, username: { eq: "baredfootwear" } }
        sort: { _createdAt: DESC }
        limit: 10
      ) {
        edges {
          node {
            ...GatsbyInstagramFragment
          }
        }
      }

      baredfootwearmens: allSanityInstagram(
        filter: { timestamp: { ne: "" }, username: { eq: "baredfootwearmens" } }
        sort: { _createdAt: DESC }
        limit: 10
      ) {
        edges {
          node {
            ...GatsbyInstagramFragment
          }
        }
      }
    }
  `;
  const queryResults = useStaticQuery(query);

  const posts =
    username && username in FilterUsernames
      ? queryResults[username]?.edges
      : [
          ...(queryResults[FilterUsernames.baredfootwear]?.edges || []),
          ...(queryResults[FilterUsernames.baredfootwearmens]?.edges || []),
        ];

  const items = posts
    ?.sort((a, b) => {
      const timeA = new Date(b.node.timestamp);
      const timeB = new Date(a.node.timestamp);
      return timeA.getTime() - timeB.getTime();
    })
    .map(({ node }) => ({
      postImage: node?.postImage?.asset,
      productHandle: node?.productHandle,
    }))
    // Hide posts which could not resolve an image from Sanity.
    .filter((post) => !!post.image || !!post.postImage);

  return {
    items,
  };
};
